<template>
  <div class="detail-main">
    <!-- 步骤条 -->
    <div>
      <StepsProcess :active="dataList.status + 1" />
    </div>
    <div class="collpase">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item :title="dataList.typeName" name="1">
          <div>
            <div class="explaintype">
              {{ $t('problemSpot') }}：
              <span v-for="(item, index) in dataList.typeItems" :key="index">
                {{ item }},
              </span>
            </div>
            <div class="explain">{{ $t('description') }}：{{ dataList.content }}</div>
            <div class="img-show">
              <div
                class="image"
                v-for="(item, index) in dataList.picUrls"
                :key="index"
              >
                <img :src="item.url" alt="" />
              </div>
            </div>
            <div class="adress-time">
              <div>{{ (language == 'CN' ? dataList.branchName : dataList.branchNameEn) || $t('noBRanch') }}</div>
              <div>{{ dataList.createTime }}</div>
            </div>
            <div class="adress-time user-name">
              <div>{{ dataList.serialNo }}</div>
              <div>
                <span>{{ language == 'CN' ? dataList.customerName : dataList.customerNameEn }}</span>
                <span> {{ dataList.phone }}</span>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <!-- 对话区 -->
    <div class="dialogue-main">
      <div v-for="item in speekList" :key="item.messageId">
        <div class="left-side" v-if="item.userType == 2">
          <div class="counten">
            {{ item.message }}
          </div>
          <div class="timeAdd">{{ item.userName }} {{ item.createTime }}</div>
        </div>
        <div class="right-side" v-else>
          <div class="counten">
            {{ item.message }}
          </div>
          <div class="timeAdd">{{ item.createTime }}</div>
        </div>
      </div>
    </div>
    <!-- 留言 -->
    <div class="leave-message">
      <div class="top">
        <div>{{ $t('messageTitle') }}</div>
      </div>
      <div class="input">
        <van-field
          v-model="inputMessage"
          rows="2"
          autosize
          type="textarea"
          :placeholder="$t('messagePlaceholder')"
        />
      </div>
      <div class="send-btn" @click="handleSendMessage">{{ $t('send') }}</div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import StepsProcess from "../../components/StepsProcess.vue";
export default {
  components: {
    StepsProcess,
  },
  data() {
    return {
      active: 0,
      activeName: "1",
      inputMessage: "",
      dataList: {},
      speekList: [],
      language: ''
    };
  },
  mounted() {
    this.dataList = this.$route.params;
    console.log(this.dataList);
    this.getSpeekList();
    this.language = localStorage.getItem('language');
  },
  methods: {
    //获取对话列表
    getSpeekList() {
      let serialNo = this.dataList.serialNo;
      this.$authAjax
        .post(`/api/wxapp/feedback/msg/list?serialNo=${serialNo}`)
        .then((res) => {
          let { data } = res.data;
          data.map((item) => {
            item.createTime = dayjs(item.createTime).format('HH:mm');
          });
          this.speekList = data;
          // console.log(this.speekList,'this.speekList');
          
        });
    },
    //发送消息
    handleSendMessage() {
      if(!this.inputMessage) {
        return this.$toast(this.$t('messagePlaceholder'));
      }
      let data = {
        shopId: this.dataList.shopId,
        branchId: this.dataList.branchId,
        serialNo: this.dataList.serialNo,
        userType: 1,
        userId: this.dataList.customerId,
        targetUserType: 2,
        targetUserId: this.dataList.customerId,
        message: this.inputMessage,
      };
      this.$authAjax.post("/api/wxapp/feedback/msg/send", data).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.inputMessage = "";
          this.getSpeekList();
        } else {
          this.$toast(res.data.message);
        }
      });
    },
    //拨打电话
    handleTelPhone() {
      window.location.href = "tel:15538223505";
    },
  },
};
</script>

<style lang="scss" scoped>
@function toVw($px) {
  @return ($px / 375) * 100vw;
}
@function toVh($px) {
  @return ($px / 667) * 100vh;
}
.detail-main {
  width: 100vw;
  height: 100%;
  overflow: auto;
  padding: toVh(14) toVw(14);
  box-sizing: border-box;
  .collpase {
    margin-top: toVh(8);
    ::v-deep .van-cell__title {
      font-size: toVw(17);
      font-weight: 500;
      color: #50b281;
      line-height: toVh(19);
    }
    ::v-deep.van-cell {
      border-radius: 8px 8px 0 0;
    }
    ::v-deep .van-collapse-item__wrapper {
      border-radius: 0 0 10px 10px;
    }
    .explain {
      font-size: toVw(15);
      font-weight: 400;
      color: #202020;
      line-height: toVh(23);
    }
    .explaintype {
      font-size: toVw(15);
      font-weight: 400;
      color: #202020;
      line-height: toVh(23);
    }
    .img-show {
      display: flex;
      align-items: center;
      .image {
        width: toVw(48);
        height: toVh(36);
        border-radius: 4px 4px 4px 4px;
        overflow: hidden;
        margin: toVh(10) toVw(8) 0 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .adress-time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: toVh(10);
      div {
        font-size: toVw(14);
        font-weight: 400;
        color: #909090;
        line-height: toVh(17);
      }
    }
    .user-name {
      margin-top: toVh(4);
    }
  }
  .leave-message {
    width: toVw(375);
    height: toVh(185);
    background: #ffffff;
    box-shadow: 0px -2px 4px 1px rgba(164, 164, 164, 0.1);
    position: fixed;
    bottom: 0;
    left: 0;
    padding: toVh(16) toVw(16) toVh(12) toVw(16);
    box-sizing: border-box;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        font-size: toVw(15);
        font-weight: 400;
        color: #909090;
        line-height: toVh(17);
        img {
          width: toVw(20);
          height: toVh(20);
        }
      }
    }
    .input {
      margin-top: toVh(12);
      ::v-deep .el-input .el-input__inner {
        width: toVw(343);
        height: toVh(100);
        background: #f7f8fa;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .send-btn {
      width: toVw(98);
      height: toVh(36);
      background: linear-gradient(134deg, #4bd891 0%, #05a856 100%);
      border-radius: 23px 23px 23px 23px;
      font-size: toVw(17);
      font-weight: 500;
      color: #ffffff;
      line-height: toVh(36);
      text-align: center;
      margin-top: toVh(12);
      margin-left: toVw(245);
    }
  }
  .dialogue-main {
    margin-top: toVh(16);
    margin-bottom: toVh(225);
    .left-side {
      max-width: toVw(288);
      .counten {
        min-width: toVw(15);
        min-height: toVh(42);
        background: #ffffff;
        box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
        font-size: toVw(15);
        font-weight: 400;
        color: #202020;
        line-height: toVh(23);
        border-radius: 0 8px 8px 8px;
        padding: toVh(12) toVw(16);
        box-sizing: border-box;
      }
      .timeAdd {
        font-size: toVw(12);
        font-weight: 400;
        color: #808080;
        line-height: toVh(16);
        margin-top: toVh(4);
        margin-left: toVw(8);
      }
    }
    .right-side {
      max-width: toVw(288);
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .counten {
        min-width: toVw(15);
        min-height: toVh(42);
        background: #d5f1e5;
        box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
        font-size: toVw(15);
        font-weight: 400;
        color: #202020;
        line-height: toVh(23);
        border-radius: 0 8px 8px 8px;
        padding: toVh(12) toVw(16);
        box-sizing: border-box;
      }
      .timeAdd {
        font-size: toVw(12);
        font-weight: 400;
        color: #808080;
        line-height: toVh(16);
        margin-top: toVh(4);
        margin-left: toVw(8);
      }
    }
  }
}
</style>
